<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  styleClass="p-fluid work-creation-dialog" [style]="showRecurrencePanel ? {'width': '90vw', 'max-width': '90vw'} : {'width': '60vw', 'max-width': '60vw'}"
  [header]="'mobile-status.mobile-worklist.createNewWork' | translate">

  <form [formGroup]="workForm" (ngSubmit)="onSubmit()">
    <div class="dialog-content">

      <div class="main-form-panel" [ngClass]="{'with-recurrence': showRecurrencePanel}">
        <div class="form-section">

          <div class="form-field">
            <label for="title" class="field-label">
              {{'mobile-status.mobile-worklist.workTitle' | translate}}
              <span class="required">*</span>
            </label>
            <input type="text" id="title" formControlName="title" class="form-input"
              [placeholder]="'mobile-status.mobile-worklist.enterWorkTitle' | translate" />
            <small class="error-message" *ngIf="workForm.get('title')?.invalid && workForm.get('title')?.touched">
              {{'mobile-status.mobile-worklist.workTitleInvalid' | translate}}
            </small>
          </div>

          <div class="form-field">
            <label for="description" class="field-label">
              {{'mobile-status.mobile-worklist.description' | translate}}<span class="required">*</span>
            </label>
            <textarea id="description" class="form-textarea" rows="3" placeholder="İş açıklaması giriniz..."
              formControlName="description"></textarea>
            <small class="error-message"
              *ngIf="workForm.get('description')?.invalid && workForm.get('description')?.touched">
              {{'mobile-status.mobile-worklist.workDescInvalid' | translate}}
            </small>
          </div>

          <div class="form-row p-col-12">
            <div class="form-field p-col-6">
              <label for="workDate" class="field-label">
                {{ 'mobile-status.mobile-worklist.workDate' | translate }} <span class="required">*</span>
              </label>
              <!-- <p-calendar formControlName="workDate" [placeholder]="'mobile-status.mobile-worklist.startDate' | translate"
                [showTime]="true" [showButtonBar]="true" appendTo="body" [dateFormat]="'dd.mm.yy'" hourFormat="24"
                [minDate]="minWorkDate" styleClass="custom-calendar" /> -->
                <p-calendar
  formControlName="workDate"
  [placeholder]="'mobile-status.mobile-worklist.startDate' | translate"
  [showTime]="true"
  [hideOnDateTimeSelect]="false"
  [showButtonBar]="true"
   [readonlyInput]="false"
  appendTo="body"
  [autoZIndex]="true"
  [baseZIndex]="12000"
  panelStyleClass="work-calendar-panel"
  [dateFormat]="'dd.mm.yy'"
  hourFormat="24"
  [minDate]="minWorkDate"
  styleClass="custom-calendar">
</p-calendar>
              <small class="error-message"
                *ngIf="workForm.get('workDate')?.invalid && workForm.get('workDate')?.touched">
                {{'mobile-status.mobile-worklist.dateInvalid' | translate}}
              </small>
              <small class="error-message"
                *ngIf="workDateBeforeAlarmTimeError">
                  {{ 'mobile-status.mobile-worklist.controlDates' | translate }}
              </small>
            </div>

            <div class="form-field p-col-6">
              <label for="alarmTime" class="field-label">
                {{'mobile-status.mobile-worklist.alarmClokDate' | translate}}<span class="required">*</span>
              </label>
              <!-- <p-calendar id="alarmTime" formControlName="alarmTime"
                [placeholder]="'mobile-status.mobile-worklist.alarmClokDate' | translate" [showTime]="true" [showButtonBar]="true"
                appendTo="body" [dateFormat]="'dd.mm.yy'" hourFormat="24" styleClass="custom-calendar" /> -->
                <p-calendar
  id="alarmTime"
  formControlName="alarmTime"
  [placeholder]="'mobile-status.mobile-worklist.alarmClokDate' | translate"
  [showTime]="true"
  [hideOnDateTimeSelect]="false"
  [showButtonBar]="true"
   [readonlyInput]="false"
  appendTo="body"
  [autoZIndex]="true"
  [baseZIndex]="12000"
  panelStyleClass="work-calendar-panel"
  [dateFormat]="'dd.mm.yy'"
  hourFormat="24"
  styleClass="custom-calendar">
</p-calendar>
              <small class="error-message"
                *ngIf="workForm.get('alarmTime')?.invalid && workForm.get('alarmTime')?.touched">
                {{'mobile-status.mobile-worklist.dateInvalid' | translate}}</small>
            </div>
          </div>

          <!-- Öncelik ve Takım -->
          <div class="form-row p-col-12">
            <div class="form-field p-col-6">
              <label for="priority" class="field-label">
                {{'mobile-status.mobile-worklist.priority' | translate}}
              </label>
              <p-dropdown id="priority" formControlName="priorityId" [options]="priorityOptions"
                [placeholder]="'mobile-status.mobile-worklist.priority' | translate" optionLabel="label" optionValue="value"
                appendTo="body"></p-dropdown>

            </div>

            <div class="form-field p-col-6">
              <label for="teams" class="field-label">
                {{'mobile-status.mobile-worklist.team' | translate}} <span class="required">*</span>
              </label>
              <p-multiSelect id="teams" formControlName="teamIds" [options]="teamsOptions" appendTo="body"
                [placeholder]="'mobile-status.mobile-worklist.team' | translate" optionLabel="label" optionValue="value"
                [filter]="true" filterBy="label" styleClass="custom-multiselect"></p-multiSelect>
              <small class="error-message" *ngIf="workForm.get('teamIds')?.invalid && workForm.get('teamIds')?.touched">
                {{'mobile-status.mobile-worklist.teamInvalid' | translate}}
              </small>
            </div>
          </div>

          <div class="form-field-checkbox">
            <p-checkbox id="isRecurring" formControlName="isRecurring" [binary]="true"
              styleClass="custom-checkbox"></p-checkbox>
            <label for="isRecurring" class="checkbox-label">
              {{'mobile-status.mobile-worklist.isRecurring' | translate}}
            </label>
          </div>

        </div>
      </div>

      <div class="recurrence-panel" *ngIf="showRecurrencePanel">
        <div class="recurrence-content">
          <div class="panel-header">
            <h4 class="panel-title">
              <i class="pi pi-calendar"></i>
              {{'mobile-status.mobile-worklist.recurrencePanel' | translate}}
            </h4>
          </div>

          <form [formGroup]="recurrenceForm" class="recurrence-form">

            <div class="form-field">
              <label class="field-label" for="">
                {{'mobile-status.mobile-worklist.endDate' | translate}} <span class="required">*</span>
              </label>
              <p-calendar dateFormat="dd.mm.yy" formControlName="endDate"
                [placeholder]="'mobile-status.mobile-worklist.endDate' | translate" [showTime]="false"
                [minDate]="workForm.get('workDate')?.value" [showButtonBar]="true" appendTo="body"
                (onSelect)="generateRecurrenceSchedule()" styleClass="custom-calendar"></p-calendar>
              <small class="error-message"
                *ngIf="recurrenceForm.get('endDate')?.invalid && recurrenceForm.get('endDate')?.touched">
                {{'mobile-status.mobile-worklist.endDateInvalid' | translate}}
              </small>
            </div>

            <div class="form-field">
              <label class="field-label" for="">
                Şu kadar günde bir <span class="required">*</span>
              </label>
              <input type="number" class="form-input" formControlName="intervalValue" min="1"
                [placeholder]="'mobile-status.mobile-worklist.interDay' | translate" />
              <small class="error-message"
                *ngIf="recurrenceForm.get('intervalValue')?.invalid && recurrenceForm.get('intervalValue')?.touched">
                Gün aralığı zorunludur
              </small>
            </div>

            <div class="preview-button-container">
              <button type="button" class="preview-button" (click)="generateRecurrenceSchedule()">
                <i class="pi pi-eye"></i>
                {{'mobile-status.mobile-worklist.scheduled' | translate}}
              </button>
            </div>

            <div class="schedule-preview" *ngIf="recurrenceSchedule.length > 0">
              <div class="schedule-header">
                <h5>Oluşturulacak İşler</h5>
                <span class="schedule-count">{{ recurrenceSchedule.length }} adet</span>
              </div>

              <div class="schedule-list">
                <div class="schedule-item" *ngFor="let date of recurrenceSchedule; let i = index">
                  <div class="schedule-item-content">
                    <div class="schedule-dates">
                      <div class="date-info">
                        <span class="date-label">{{'mobile-status.mobile-worklist.workDate' | translate}}:</span>
                        <span class="date-value">{{ date.startDate | date: 'dd.MM.yyyy HH:mm' }}</span>
                      </div>
                      <div class="date-info">
                        <span class="date-label">{{'mobile-status.mobile-worklist.alarmClokDate' | translate}}:</span>
                        <span class="date-value">{{ date.endDate | date: 'dd.MM.yyyy HH:mm' }}</span>
                      </div>
                    </div>
                    <button type="button" class="delete-button" (click)="removeScheduleItem(i)" title="Sil">
                      <i class="pi pi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>

    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button type="button" class="cancel-button" (click)="onCancel()" [disabled]="loading">
        <i class="pi pi-times"></i>
        {{'mobile-status.mobile-worklist.cancel' | translate}}
      </button>
      <button type="button" class="save-button" (click)="onSubmit()" [disabled]="workForm.invalid || loading">
        <i class="pi pi-check" *ngIf="!loading"></i>
        <i class="pi pi-spinner pi-spin" *ngIf="loading"></i>
        {{'mobile-status.mobile-worklist.save' | translate}}
      </button>
    </div>
  </ng-template>

</p-dialog>